import script from "./InvitationAcceptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationAcceptModal.vue?vue&type=script&setup=true&lang=js"

import "./InvitationAcceptModal.vue?vue&type=style&index=0&id=0164d489&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0164d489"]])

export default __exports__